
export enum Access {
	ativado = "ativo",
	negado = "negado",
}